<template>
  <div>
    <v-menu offset-y>
      <template #activator="{ on, attrs }">
        <v-btn
          text
          tile
          class="text-subtitle-2"
          v-bind="attrs"
          data-cy="timer-button"
          v-on="on"
        >
          {{ tempoRestanteSessao }}
          <v-icon class="pl-2" :color="corRelogio" data-cy="timer-button-icon">
            mdi-timer-outline
          </v-icon>
        </v-btn>
      </template>

      <v-list dense data-cy="timer-list">
        <v-list-item link data-cy="timer-list-item" @click="renovarSessao">
          <v-list-item-title data-cy="timer-list-item-title">
            <v-icon class="pr-2" color="primary" data-cy="timer-list-item-icon">
              mdi-refresh-circle
            </v-icon>
            Renovar Sessão
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
const UM_SEGUNDO = 1000;
const MEIO_SEGUNDO = 500;

export default {
  data() {
    return {
      tempoRestanteSessao: '',
      segundosRestantes: 0,
      corRelogio: 'green',
      usuario: null,
      temporizador: null
    };
  },

  mounted() {
    this.atualizarTempoExpiracao();

    if (this.segundosRestantes > 0) {
      this.iniciarContagemRegressiva();
    }
  },

  beforeDestroy() {
    clearTimeout(this.temporizador);
  },

  methods: {
    iniciarContagemRegressiva() {
      const usuarioLogado = this.atualizarTempoExpiracao();

      if (this.segundosRestantes <= 0) {
        this.exibirSessaoExpirada();
        return;
      }

      this.atualizarRelogio();

      if (usuarioLogado) {
        this.temporizador = setTimeout(
          this.iniciarContagemRegressiva,
          UM_SEGUNDO
        );
      }
    },

    atualizarRelogio() {
      const minutos = Math.trunc(this.segundosRestantes / 60);
      const segundos = this.segundosRestantes % 60;

      this.corRelogio = minutos === 0 ? 'amber' : 'green';
      this.tempoRestanteSessao = [minutos, segundos]
        .map(valor => String(valor).padStart(2, '0'))
        .join(':');
    },

    exibirSessaoExpirada() {
      this.corRelogio = 'red';
      this.tempoRestanteSessao = '00:00';
      this.$api.UI.Confirmacao(
        'info',
        'Deseja renovar a sessão?',
        () => this.renovarSessao(),
        () => this.$store.dispatch('logout'),
        'Sessão expirada'
      );
    },

    atualizarTempoExpiracao() {
      const status = localStorage.getItem('status');
      this.usuario = this.$store.getters.user;

      if (!status) {
        return true;
      }

      if (status !== 'loggedIn') {
        setTimeout(this.$store.dispatch('logout'), 3000);
        return false;
      }

      if (!this.usuario) {
        this.usuario = JSON.parse(localStorage.getItem('user'));
      }

      const expiracao = new Date(this.usuario.expiresAt).getTime();
      const agora = Date.now();
      this.segundosRestantes = Math.trunc((expiracao - agora) / UM_SEGUNDO);

      return true;
    },

    async renovarSessao() {
      try {
        const dadosToken = await this.$api.Autenticacao.RefreshToken(
          this.usuario.refreshToken
        );
        const usuarioAtualizado = await this.$utils.salvarSessaoAutenticada({
          api: this.$api,
          store: this.$store,
          dadosToken,
          identificador: this.usuario.identificador,
          empresaLogada: this.$utils.buscaEPCodigo(this.$store)
        });

        if (!usuarioAtualizado) {
          this.$api.UI.ShowError('Erro', 'Não foi possível renovar a sessão');
          setTimeout(this.$store.dispatch('logout'), 3000);
          return;
        }

        this.usuario = usuarioAtualizado;

        if (this.segundosRestantes <= 0) {
          this.temporizador = setTimeout(
            this.iniciarContagemRegressiva,
            MEIO_SEGUNDO
          );
        }

        const expiracao = new Date(usuarioAtualizado.expiresAt).getTime();
        this.segundosRestantes = Math.trunc(
          (expiracao - Date.now()) / UM_SEGUNDO
        );
      } catch (error) {
        this.$api.UI.ShowError('Erro', 'Erro ao renovar sessão');
        setTimeout(this.$store.dispatch('logout'), 3000);
      }
    }
  }
};
</script>
